import './styles.scss';

import logo from "../../../images/kashable-logo-light.svg";

import React from 'react';

import {Link} from "react-router-dom";

export const UnsecuredLogo = () => {
    return (
        <Link
            className='unsecured-logo-component'
            title='Return to Main Page'
            aria-label='Return to Main Page'
            to='/'>
            <img alt='Kashable Logo' src={logo}/>
        </Link>
    );
};
